import { render, staticRenderFns } from "./TgMobileGameTitle.vue?vue&type=template&id=e239dc9a&"
import script from "./TgMobileGameTitle.vue?vue&type=script&lang=js&"
export * from "./TgMobileGameTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports